import AddIcon from "@mui/icons-material/Add";
import { Button, Paper } from "@mui/material";
import CustomText from "components/typography/CustomText";
import { ERR_NETWORK } from "constants/messages";
import { modifyArray, removeItemArray } from "lib/arrayObject";
import { getWeeklyNumbers } from "lib/date";
import { serverGet, serverPost } from "lib/serverRequest";
import moment from "moment";
import { useSnackbar } from "notistack";
import { useEffect, useRef, useState } from "react";
import { closeModal, openLoading, openModal } from "store/reducers/tools";
import BlackoutDatesTable from "./BlackoutDatesTable";
import BlackoutDayForm from "./BlackoutDayForm";

export default function BlackoutDatesComponent() {
  const addFormRef = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState([]);

  const errorAction = (res, err) => {
    if (!res && err?.message) {
      enqueueSnackbar(err?.message, { variant: "warning" });
    } else {
      enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
    }
  };

  const loadData = () => {
    serverGet({
      url: "blackout-day",
      onFinish: (res, err) => {
        if (res === false) {
          errorAction(res, err);
          return;
        }
        setData(res);
      },
    });
  };

  const handleDelete = (row = {}, index = 0) => {
    openLoading(true);
    serverGet({
      url: `blackout-day/delete/${row?.id}`,
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          errorAction(res, err);
          return;
        }
        enqueueSnackbar("Deleted successfully", { variant: "success" });
        setData((s = []) => removeItemArray(s, index));
      },
    });
  };

  const handleView = (row = {}, index = 0) => {
    openModal({
      title: "Edit Blackout Day",
      content: (
        <BlackoutDayForm
          ref={addFormRef}
          data={{
            ...row,
            blackout_day: moment(row?.blackout_day).format("YYYY-MM-DD"),
          }}
        />
      ),
      onSave: () => {
        const submitData = addFormRef.current?.prepare();
        if (submitData) {
          openLoading(true);
          serverPost({
            url: "blackout-day/update",
            data: {
              ...submitData,
              week_day: moment(submitData.blackout_day).isoWeekday(),
              week_num: moment(submitData.blackout_day).isoWeek(),
              week_year: moment(submitData.blackout_day).isoWeekYear(),
            },
            onFinish: (res, err) => {
              openLoading(false);
              if (res === false) {
                errorAction(res, err);
                return;
              }
              enqueueSnackbar("Updated successfully", { variant: "success" });
              setData((s = []) => modifyArray(s, index, ...res));
              closeModal();
            },
          });
        }
      },
    });
  };

  const handleAdd = () => {
    openModal({
      title: "Add Blackout Day",
      content: <BlackoutDayForm ref={addFormRef} />,
      onSave: () => {
        const submitData = addFormRef.current?.prepare();
        if (submitData) {
          openLoading(true);
          serverPost({
            url: "blackout-day/create",
            data: {
              ...submitData,
              ...getWeeklyNumbers(submitData.blackout_day),
            },
            onFinish: (res, err) => {
              openLoading(false);
              if (res === false) {
                errorAction(res, err);
                return;
              }
              enqueueSnackbar("Added successfully", { variant: "success" });
              setData((s = []) => [...s, ...res]);
              closeModal();
            },
          });
        }
      },
    });
  };

  useEffect(() => {
    loadData();
    //eslint-disable-next-line
  }, []);

  return (
    <div>
      <Paper>
        <div className="p-4 flex justify-between items-center border-b border-white-gray">
          <CustomText variant="h6" bold={600}>
            Blackout Days
          </CustomText>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            color="primary"
            onClick={handleAdd}
          >
            Add Blackout Day
          </Button>
        </div>
        <div className="p-4">
          <CustomText variant="body">
            Blockout specific dates within the Dispatch Schedule. These are days
            that the business will not dispatch orders.
          </CustomText>
        </div>
      </Paper>
      <BlackoutDatesTable
        data={data}
        elevation={0}
        onView={handleView}
        onDelete={handleDelete}
      />
    </div>
  );
}
